import * as React from 'react';
import ProjectComment from 'src/entities/ProjectComment';
import ProjectChildCommentCardComponent from 'src/modules/project/partials/comments/ProjectChildCommentCard.component';
import * as moment from 'moment';
import ProjectCommentInputComponent from 'src/modules/project/partials/comments/ProjectCommentInput.component';

export interface ProjectCommentCardComponentProps {
  comment: ProjectComment;
  newComment: string;
  response: boolean;
  showInputComment: (respondingTo: string, show: boolean) => void;
  handleChange: (value: string) => void;
  handleSubmit: () => void;
}

class ProjectCommentCardComponent extends React.PureComponent<ProjectCommentCardComponentProps> {

  public render(): React.ReactNode {

    return (
      <div className="padding-left-30">
        <div className="row comment-card">
          <div className="gap-20"/>
          <div className="col-xs-1 text-center">
          <span className="circle">
            {this.props.comment!.authorName![0] + this.props.comment.authorName!.split(' ')[1][0] || ''}
          </span>
          </div>
          <div className="col-xs-11">
            <h5 className="deco-title">
              {this.props.comment.authorName!},<br/>
              <span className="f-w-100 f-s-12">
              {moment(this.props.comment.createdAt!).format('DD [de] MMMM [de] YYYY [a las] HH:mm [h]')}
            </span>
            </h5>
            <div className="from-rich-editor" dangerouslySetInnerHTML={{__html: this.props.comment.body}}/>
            <div className="gap-20"/>
            <div className="comments-actions">
              <a
                className="margin-r-30 pointer c-grey"
                onClick={() => this.props.showInputComment('', true)}
              >
                <span className="reply"/>
                Responder
              </a>
              {/*TODO*/}
              {/*<a className="pointer c-grey">
                <span className="share-comment"/>
                Compartir
              </a>*/}
            </div>
            <div className="gap-20"/>
            {this.props.comment.childComments.map(
              (childComment, index) => (
                <ProjectChildCommentCardComponent
                  comment={childComment}
                  showInputComment={this.props.showInputComment}
                  key={index}
                />
              )
            )}
          </div>
        </div>
        {this.props.response ?
          <section id={'input-comment-' + this.props.comment.id!}>
            <p className="text-right">
              <span
                className="close-med pointer"
                onClick={() => this.props.showInputComment('', false)}
              />
            </p>
            <ProjectCommentInputComponent
              comment={this.props.newComment}
              handleChange={this.props.handleChange}
              handleSubmit={this.props.handleSubmit}
            />
          </section> : null
        }
      </div>
    );
  }

}

export default ProjectCommentCardComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/comments/ProjectCommentCard.component.tsx